import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

import { RouterService } from 'src/app/core/router.service';

import { Faq } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';
import { FaqService } from '../services/faq.service';

@Component({
	selector: 'pk-broker-faq-view',
	templateUrl: './faq-view.component.html',
	styleUrls: ['./faq-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FaqViewComponent extends AbstractPageForm {
	constructor(
		private route: ActivatedRoute,
		private routerService: RouterService,
		private faqService: FaqService,
	) {
		super();
		this.route.paramMap.subscribe((paramMap: ParamMap) => {
			const faqId = paramMap.get('faqId');

			if (faqId) {
				this.faqService.getFaqArticle(faqId);
			}
		});
	}

	get faqArticle(): Faq {
		return this.faqService.faqArticle;
	}
	get loadingArticle(): boolean {
		return this.faqService.loadingArticle;
	}
	get relatedArticles(): Faq[] {
		return this.faqService.relatedArticles;
	}

	public async showFaqArticle(faq: Faq): Promise<void> {
		await this.routerService.navigate(['/faq', 'view', faq.id], { relativeTo: this.route });
	}
}
